// ========================================================================
// 📁 shared/InfoCard.js & InfoRow.js
// Purpose: Simple, reusable presentational components.
// ========================================================================

export const InfoCard = ({ label, value, icon, config = {} }) => (
    <div className={`p-4 rounded-xl border ${config.bg || 'bg-gray-50'} ${config.border || 'border-gray-200'} flex items-center space-x-3`}>
        {config.icon || icon}
        <div>
            <p className="text-sm font-medium text-gray-500">{label}</p>
            <p className={`text-lg font-bold ${config.color || 'text-gray-900'}`}>{value || 'N/A'}</p>
        </div>
    </div>
);

export const InfoRow = ({ icon, label, value }) => (
    <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 text-gray-500">{icon}</div>
        <div className="flex-1">
            <p className="text-sm font-medium text-gray-500">{label}</p>
            <p className="text-gray-900 font-semibold">{value || 'N/A'}</p>
        </div>
    </div>
);
